import React from "react";
import thumb4 from "../../assets/images/about-thumb-4.png";
import thumb5 from "../../assets/images/about-thumb-5.png";

function AboutHomeEight() {
  return (
    <>
      <section className="pt-100 pb-100" id="about">
        <div className="container">
          <div className="row about-box">
            <div className="col-lg-12">
              <div className="appie-section-title mb-20 text-center">
                <h3 className="appie-title">Who we are</h3>
              </div>
              <p>
                We’re proud to be a digital enablement solutions provider that
                designs, integrates, manages, and supports on-site and
                cloud/server based communications and collaboration technologies for
                organizations around the globe.
              </p>
              <br />
              <p>
                We’ve been innovating the way work gets done and unlocking new
                business value since 2012. And we’re even more proud of what
                each of these solutions represents to our customers: modernized
                experiences that accelerate results and create flexibility in
                support of hybrid work.
              </p>
              <br />
              <p>
                Our team includes qualified consultants, system designers and
                in-house engineers to ensure the satisfaction of all client
                requirements for projects, including, but not limited to,
                prominent landmarks, universities, Sports arena, houses of
                worship and all large-scale venues that require a complete AV,
                IP and Casting Solutions.
              </p>
              <br />
              <p>
                Universe Media, works with you throughout your engagement and
                beyond to make sure your goals are achieved now – and as your
                business grows and evolves.
              </p>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-lg-6 col-md-6">
              <div
                className="
                    appie-single-service-2 appie-single-service-about
                    mt-30
                    wow
                    animated
                    fadeInUp
                  "
                data-wow-duration="2000ms"
                data-wow-delay="200ms"
              >
                <div className="icon">
                  <i className="fal fa-tv" />
                </div>
                <h4 className="title">Carefully designed</h4>
                <p>He lost his bottle loo don't get shirty with me ruddy.</p>
              </div>
            </div>

            <div className="col-lg-6 col-md-6">
              <div
                className="
                    appie-single-service-2 appie-single-service-about
                    item-2
                    mt-30
                    wow
                    animated
                    fadeInUp
                  "
                data-wow-duration="2000ms"
                data-wow-delay="400ms"
              >
                <div className="icon">
                  <i className="fal fa-code" />
                </div>
                <h4 className="title">Clean Modern Code</h4>
                <p>He lost his bottle loo don't get shirty with me ruddy.</p>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="appie-about-8-box">
                <div
                  className="
                    appie-single-service-2 appie-single-service-about
                    item-2
                    mt-30
                    wow
                    animated
                    fadeInUp
                  "
                  data-wow-duration="2000ms"
                  data-wow-delay="400ms"
                >
                  <div className="icon">
                    <i className="fal fa-code" />
                  </div>
                  <h4 className="title">Vision</h4>
                  <p>He lost his bottle loo don't get shirty with me ruddy.</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="appie-about-8-box">
                <div
                  className="
                    appie-single-service-2 appie-single-service-about
                    mt-30
                    wow
                    animated
                    fadeInUp
                  "
                  data-wow-duration="2000ms"
                  data-wow-delay="200ms"
                >
                  <div className="icon">
                    <i className="fal fa-tv" />
                  </div>
                  <h4 className="title">Mission</h4>
                  <p>He lost his bottle loo don't get shirty with me ruddy.</p>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
}

export default AboutHomeEight;
